// import { ReactComponent as Quizz } from "../images/contenticon/quiz1.svg";
// import { ReactComponent as Settings } from "../images/contenticon/setting.svg";
// import { ReactComponent as ReviewRating } from "../images/contenticon/review&rating.svg";
// import { ReactComponent as UploadPlans } from "../images/contenticon/uploadplans.svg";
// import { ReactComponent as Notes } from "../images/contenticon/notes.svg";
// import { ReactComponent as Exam } from "../images/mastericon/Exam.svg";
// import { ReactComponent as ClientExamVector } from "../images/manageicon/clientexam.svg";
// import { ReactComponent as Batch } from "../images/manageicon/batchicon.svg";
// import { ReactComponent as LearnerIcon } from "../images/manageicon/learnericon.svg";
// import { ReactComponent as AssignExamToBatch } from "../images/manageicon/assignexamtobatch.svg";

const sidePannelData = [
  {
    id: 79,
    name: "Dashboard",
    type: "link",
    icon: "Dashboard",
    path: "/admin/dashboard",
    validity: true,
    page_status: true,
  },
  {
    id: 80,
    name: "Master",
    type: "dropdown",
    icon: "Master",
    validity: true,
    page_status: true,
    menu: [
      {
        id: 93,
        name: "Courses",
        type: "link",
        path: "/admin/courses",
        validity: true,
        page_status: true,
      },
      {
        id: 94,
        name: "Batch",
        type: "link",
        path: "/admin/batch",
        validity: true,
        page_status: true,
      },
      {
        id: 95,
        name: "Subject",
        type: "link",
        path: "/admin/subject",
        validity: true,
        page_status: true,
      },
      {
        id: 98,
        name: "Section",
        type: "link",
        path: "/admin/section",
        validity: true,
        page_status: true,
      },
      {
        id: 11,
        name: "Branch",
        type: "link",
        path: "/admin/center",
        validity: true,
        page_status: true,
      },
      {
        id: 12,
        name: "Scoring Scheme",
        type: "link",
        path: "/admin/scorescheme",
        validity: true,
        page_status: true,
      },
      // {
      //   id: 12,
      //   name: "Marking System",
      //   type: "link",
      //   path: "/admin/markingsystem",
      //   validity: true,
      //   page_status: true,
      // },
      // {
      //   id: 12,
      //   name: "Generate Registration Link",
      //   type: "link",
      //   path: "/admin/registrationlink",
      //   validity: true,
      //   page_status: true,
      // },
    ],
  },
  {
    id: 81,
    name: "Learner",
    type: "dropdown",
    icon: "Learner",
    validity: true,
    page_status: true,
    menu: [
      {
        id: 96,
        name: "Add Learner",
        type: "link",
        path: "/admin/learner",
        validity: true,
        page_status: true,
      },
      {
        id: 97,
        name: "Assign Learner",
        type: "link",
        path: "/admin/assignlearner",
        validity: true,
        page_status: true,
      },
      // {
      //   id: 97,
      //   name: "Admit Card Generation",
      //   type: "link",
      //   path: "/admin/admitcard",
      //   validity: true,
      //   page_status: true,
      // },
    ],
  },
  {
    id: 83,
    name: "Exam",
    type: "link",
    icon: "Exam",
    path: "/admin/exam",
    validity: true,
    page_status: true,
  },
  {
    id: 84,
    name: "OMR",
    type: "link",
    icon: "OMRDesign",
    path: "/admin/omr",
    validity: true,
    page_status: true,
  },
  {
    id: 92,
    name: "Settings",
    type: "link",
    icon: "Settings",
    path: "/admin/settings",
    validity: true,
    page_status: true,
  },
  //   {
  //     id: 91,
  //     name: "Upgrade",
  //     type: "link",
  //     icon: "UpgradeIcon",
  //     path: "/admin/upgrade",
  //     validity: true,
  //     page_status: true,
  //   },
];
export default sidePannelData;
